import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import Switch from 'component/Switch'
import ExclusionModal from './ExclusionModal'

const SupplyTable = ({
  justifications,
  handleSingleEditModal,
  translate,
  updateStatus,
  handleDelete,
}) => {
  const tableRef = useRef(null)
  const [height,setHeight] = useState(0)
  // Pagination below table
  const PAGINATION_HEIGHT = 71
  // Search and Filter
  const TOP_ACTIONS = 95
  // TOOLBAR + Title
  const TOP_BAR = 67 + 50

  useEffect(() => {
    setHeight(window.innerHeight)
    const calculateHeight = () => {
      setHeight(window.innerHeight)}
    window.addEventListener("resize", calculateHeight)
    return () => window.removeEventListener("resize", calculateHeight)
  }, [])

  useEffect(() => {

    if(height < 868 && height !== 0) {
      const responsiveHeight = height - (PAGINATION_HEIGHT + TOP_ACTIONS + TOP_BAR + 100)
      const tbody = document.querySelector('.tbody-mission-block')
      tbody.style.maxHeight = `${responsiveHeight}px`
    }
    else {
      const tbody = document.querySelector('.tbody-mission-block')
      tbody.style.maxHeight = `500px`
    }
  }, [height])
  const renderHeader = () => (
      <tr className='pictograms-tr'>
       <th style={{width: "32%"}} >Justificativa</th>
       <th style={{width: "32%"}} >Tipo</th>
       <th style={{width: "20%"}} >Status</th>
       
       <th  style={{width: "8%"}}  className='text-center'>
         Editar
       </th>
      
       <th  style={{width: "8%"}} className='text-center'>
         Excluir
       </th>
       
      </tr>
    )

  const renderBody = () => {

    const renderRecord = (record) => {
      const { idJustification, active, type } = record

      return (
        <tr key={idJustification}>
        
        <td className='CellWithComment' style={{width: "32%"}} > <span className='list-description'>{record.dsJustification}</span></td>
        <td style={{width: "32%",textTransform: "capitalize"}} >{record.dsType}</td>
        <td style={{width: "20%", fontSize: '14px', display: 'flex', flexDirection: "row", alignItems: "center", gap: "15px"}} >  
          <Switch onChange={(state) => {
          updateStatus(idJustification, state, type)
        }} 
        defaultValue={active} 
        noLabel name='switch1' /> {active ? "Ativado" : "Desativado"} </td>
      
        <td onClick={() => handleSingleEditModal(record)}  style={{width: "8%"}} className='text-center'>
         
          <i style={{cursor: 'pointer'}} className=' glyph glyph-pencil icon-size color-primary' />
           
        </td>

        <td  style={{width: "8%"}} >
            <ExclusionModal
                      t={translate}
                      title={"Excluir"}
                      onConfirm={() => {
                        handleDelete({
                          idJustification: record.idJustification,
                          dsJustification: record.dsJustification,
                          dsType: record.dsType,
                        })}}
                      message={
                        <>
                          <br />
                          {translate('justificationsPa.removeModal.text')}
                          <br />
                          <b> {record.dsJustification} </b>
                        </>
                      }
                      confirmButtonMsg='approvers.remove.confirm'
                      renderButton={({ onClick }) => (
                        <a
                          idJustification={`view-mission-${idJustification}`}
                          role='button'
                          onClick={onClick}
                        >
                          <i className='font-20 color-danger glyph glyph-trash-can icon-size' />
                        </a>
                      )}
                    />
        </td>
        
        </tr>
      
      )
    }

    return justifications.map(renderRecord)
  }

  return (
    <table  cellPadding={0} cellSpacing={0} className={`supply-list-table-new new pictograms-table }`}>
      <thead ref={tableRef}>{renderHeader()}</thead>
      <tbody className='tbody-mission-block'  onScroll={(e) => {
        if(e.currentTarget.scrollTop > 20) {
          tableRef.current.classList.add("shadow-table-header-mission-block")
        }
        else {
          tableRef.current.classList.remove("shadow-table-header-mission-block")
        }
      }} >{renderBody()}</tbody>
      <tfoot style={{height: "1px",background:"#D3D2D6"}}></tfoot>
    </table>
  )
}

SupplyTable.propTypes = {
  cdMissionList: PropTypes.array.isRequired,
  editModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  handleResize: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  justifications: PropTypes.array.isRequired,
  setCdMissionList: PropTypes.func.isRequired,
  size: PropTypes.number.isRequired,
  translate: PropTypes.func.isRequired,
  removeSelected: PropTypes.func.isRequired,
  handleOrder: PropTypes.func.isRequired,
  showViewModal:PropTypes.bool,
  handleSyncModal: PropTypes.func.isRequired,
  handleDelete: PropTypes.bool.isRequired,
  handleSingleEditModal: PropTypes.func.isRequired,
  updateStatus: PropTypes.func.isRequired
}

export default SupplyTable
